function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmployeeInsurance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 181.13 201.22"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M131.31 159.32a19.77 19.77 0 1 0-19.74-19.76 19.84 19.84 0 0 0 19.74 19.76Zm0-4.82a14.95 14.95 0 1 1 14.92-14.94 15 15 0 0 1-14.92 14.94ZM57.45 48.34h57.76v7.53H57.45zM38.61 82.25h76.6v7.53h-76.6z",
  style: {
    fill: "#ad112b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.53 7.53v157h74.08a51.18 51.18 0 0 1 7-40.8h-50v-7.54h56.05a51.15 51.15 0 0 1 51-13.3V7.53Z",
  style: {
    fill: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.53 164.49V7.53h138.13v95.32a50.18 50.18 0 0 1 7.53 2.87V0H0v172h84.15a49.49 49.49 0 0 1-2.54-7.54Z",
  style: {
    fill: "#ad112b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.61 116.15v7.54h50a50.93 50.93 0 0 1 6.1-7.54ZM163.39 180.21a34.21 34.21 0 0 0-63.82-.85 43.51 43.51 0 0 0 3.77 3.91 29.32 29.32 0 0 1 56.16.74 42.28 42.28 0 0 0 3.89-3.8Z",
  style: {
    fill: "#ad112b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.22 201.22a49.91 49.91 0 1 1 49.91-49.91 50 50 0 0 1-49.91 49.91Zm0-92.29a42.38 42.38 0 1 0 42.38 42.38 42.43 42.43 0 0 0-42.38-42.38ZM55.66 36.9a1.23 1.23 0 0 1 .4.9.93.93 0 0 1-.4.79l-17.14 17a1.25 1.25 0 0 1-.9.39.94.94 0 0 1-.79-.39l-9.07-9.07a1.24 1.24 0 0 1-.4-.9 1 1 0 0 1 .4-.8l2.29-2.29a1.07 1.07 0 0 1 .8-.3 1.43 1.43 0 0 1 .89.3l5.88 6.08 14.15-14a1.09 1.09 0 0 1 .8-.3 1.24 1.24 0 0 1 .9.4Z",
  style: {
    fill: "#ad112b"
  }
}));
export default SvgEmployeeInsurance;